import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAppSelector } from "../hooks/redux-hooks";

const ProtectedDriverLayout = () => {
  const driverInfo = useAppSelector((state) => state.auth.driverInfo);

  if (!driverInfo) {
    return <Navigate replace to={"/driver-login"} />;
  }


  return (
    <>
      <Outlet />
    </>
  );
};

export default ProtectedDriverLayout;
